import { useCallback, useState } from "react";
import type { Work } from "@/types";
import { works } from "@/mocks/works";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import RankingSection from "./components/RankingSection";
import UpdatesSection from "./components/UpdatesSection";
import LibrarySection from "./components/LibrarySection";
import GenreSection from "./components/GenreSection";
import FeaturedSection from "./components/FeaturedSection";
import DiscoverSection from "./components/DiscoverSection";
import GuideSection from "./components/GuideSection";
import FaqSection from "./components/FaqSection";
import Footer from "./components/Footer";

const categories = ["全部", "韩漫", "国漫", "动漫"];
const allWorks = works as Work[];

export default function Home() {
  const [activeCategory, setActiveCategory] = useState("全部");
  const [activeGenre, setActiveGenre] = useState("全部");
  const [keyword, setKeyword] = useState("");

  const handlePickGenre = useCallback((genre: string) => {
    setActiveCategory("全部");
    setActiveGenre(genre);
    setKeyword("");
    const target = document.getElementById("library");
    if (target) {
      window.setTimeout(() => target.scrollIntoView({ behavior: "smooth", block: "start" }), 60);
    }
  }, []);

  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      <Navbar />
      <main className="flex-1">
        <Hero />
        <RankingSection />
        <UpdatesSection />
        <LibrarySection
          works={allWorks}
          categories={categories}
          activeCategory={activeCategory}
          onCategoryChange={setActiveCategory}
          activeGenre={activeGenre}
          onGenreChange={setActiveGenre}
          keyword={keyword}
          onKeywordChange={setKeyword}
        />
        <GenreSection works={allWorks} onPickGenre={handlePickGenre} />
        <FeaturedSection />
        <DiscoverSection />
        <GuideSection />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}